import { render, staticRenderFns } from "./UiBracketItemPlayer.vue?vue&type=template&id=1c3fcce9&"
import script from "./UiBracketItemPlayer.vue?vue&type=script&lang=js&"
export * from "./UiBracketItemPlayer.vue?vue&type=script&lang=js&"
import style0 from "./UiBracketItemPlayer.vue?vue&type=style&index=0&id=1c3fcce9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports